(function () {
  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var form = root.closest('form');
    if (!form) return;
    var select = form.querySelector('[data-variant-select]');
    var qtyInput = form.querySelector('[data-band-quantity]');
    var submitBtn = form.querySelector('[data-primary-product-submit]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    var preorderProperty = form.querySelector('[data-preorder-property]');
    var deliveryReassurance = form.querySelector('[data-delivery-reassurance]');
    var mapEl = root.querySelector('[data-band-variant-map]');
    if (!select || !mapEl) return;
    var variants = [];
    try { variants = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var packSize = 1;
    var slots = [null];
    var active = 0;
    var draft = { size: null, color: null };

    var ps = root.querySelector('[data-band-size][aria-pressed="true"]');
    var pc = root.querySelector('[data-band-color][aria-pressed="true"]');
    if (ps) draft.size = ps.getAttribute('data-band-size');
    if (pc) draft.color = pc.getAttribute('data-band-color');
    if (draft.size && draft.color) slots[0] = { size: draft.size, color: draft.color };

    function find(size, color) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].size === size && variants[i].color === color) return variants[i];
      }
      return null;
    }
    function filled() { return slots.filter(function (s) { return s; }).length; }
    function firstEmpty() {
      for (var i = 0; i < slots.length; i++) { if (!slots[i]) return i; }
      return -1;
    }
    function isFull() { return firstEmpty() === -1; }
    function anyPreorder() {
      return slots.some(function (s) { var v = s && find(s.size, s.color); return !!(v && v.preorder); });
    }
    // Lowest-stock band currently in the pack (or the single selected band).
    function lowestInPack() {
      var low = null;
      slots.forEach(function (s) {
        var v = s && find(s.size, s.color);
        if (v && v.low && (!low || v.qty < low.qty)) low = v;
      });
      return low;
    }

    function setPack(n) {
      packSize = n;
      var next = [];
      for (var i = 0; i < n; i++) next.push(slots[i] || null);
      slots = next;
      if (n === 1 && !slots[0] && draft.size && draft.color) {
        slots[0] = { size: draft.size, color: draft.color };
      }
      var e = firstEmpty();
      active = e === -1 ? (n - 1) : e;
      if (n === 1) {
        if (slots[0]) draft = { size: slots[0].size, color: slots[0].color };
      } else if (slots[active]) {
        draft = { size: slots[active].size, color: slots[active].color };
      } else {
        draft = { size: draft.size, color: null };
      }
      render();
    }

    // Only writes into a slot that is currently open (null).
    function commit() {
      if (!draft.size || !draft.color) return false;
      if (slots[active] !== null && slots[active] !== undefined) return false;
      slots[active] = { size: draft.size, color: draft.color };
      var e = firstEmpty();
      if (e !== -1) { active = e; draft = { size: draft.size, color: null }; }
      render();
      return true;
    }

    function renderTray() {
      var tray = root.querySelector('[data-pack-tray]');
      var list = root.querySelector('[data-pack-list]');
      var count = root.querySelector('[data-pack-count]');
      var mix = root.querySelector('[data-mix-note]');
      tray.hidden = packSize < 2;
      mix.hidden = packSize < 2;
      if (packSize < 2) return;
      count.textContent = filled() + ' of ' + packSize + ' chosen';
      list.innerHTML = '';
      slots.forEach(function (s, i) {
        var v = s ? find(s.size, s.color) : null;
        var li = document.createElement('li');
        li.className = 'pack-slot' + (i === active && !v ? ' is-active' : '') + (v ? '' : ' is-empty');
        var num = document.createElement('span');
        num.className = 'pack-slot__num';
        num.textContent = String(i + 1);
        var thumb = document.createElement('span');
        thumb.className = 'pack-slot__thumb';
        if (v && v.img) {
          var im = document.createElement('img');
          im.src = v.img; im.alt = ''; im.loading = 'lazy';
          thumb.appendChild(im);
        }
        var text = document.createElement('span');
        text.className = 'pack-slot__text';
        var b = document.createElement('b');
        var sub = document.createElement('span');
        if (v) { b.textContent = v.colorShort; sub.textContent = v.sizeShort; }
        else { b.textContent = 'Choose band ' + (i + 1); sub.textContent = 'Pick a size and color below'; }
        text.appendChild(b); text.appendChild(sub);
        li.appendChild(num); li.appendChild(thumb); li.appendChild(text);
        if (v && v.preorder) {
          var tag = document.createElement('span');
          tag.className = 'pack-slot__tag';
          tag.textContent = 'Pre-order - Ships First Week of September';
          li.appendChild(tag);
        } else if (v && v.low) {
          var lowTag = document.createElement('span');
          lowTag.className = 'pack-slot__tag pack-slot__tag--low';
          lowTag.textContent = v.qty + ' left';
          li.appendChild(lowTag);
        }
        if (v) {
          var ed = document.createElement('button');
          ed.type = 'button';
          ed.className = 'pack-slot__edit';
          ed.setAttribute('data-edit-slot', String(i));
          ed.textContent = 'Change';
          li.appendChild(ed);
        }
        list.appendChild(li);
      });
    }

    function render() {
      root.querySelectorAll('[data-pack-choice]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-pack-choice')) === packSize));
      });
      root.querySelectorAll('[data-band-size]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-band-size') === draft.size));
      });
      root.querySelectorAll('[data-band-color]').forEach(function (b) {
        var val = b.getAttribute('data-band-color');
        b.setAttribute('aria-pressed', String(val === draft.color));
        var v = find(draft.size, val);
        var flag = b.querySelector('[data-flag]');
        b.classList.toggle('is-unavailable', !!v && !v.available && !v.preorder);
        if (flag) {
          flag.classList.remove('band-swatch__flag--low', 'band-swatch__flag--stock');
          if (v && v.preorder) { flag.hidden = false; flag.textContent = 'Pre-order - Ships First Week of September'; }
          else if (v && v.low) { flag.hidden = false; flag.textContent = v.qty + ' left'; flag.classList.add('band-swatch__flag--low'); }
          else if (v && !v.available) { flag.hidden = false; flag.textContent = 'Sold out'; }
          else if (v && v.available) { flag.hidden = false; flag.textContent = 'Ships now'; flag.classList.add('band-swatch__flag--stock'); }
          else { flag.hidden = true; }
        }
      });

      var sel = root.querySelector('[data-band-selection]');
      if (sel) sel.textContent = draft.color || '';

      var full = packSize > 1 && isFull();
      var ss = root.querySelector('[data-size-step]');
      var cs = root.querySelector('[data-color-step]');
      if (packSize > 1) {
        if (ss) ss.textContent = full ? '2. Size' : '2. Band ' + (active + 1) + ' of ' + packSize + ' — size';
        if (cs) cs.textContent = full ? '3. Color' : '3. Band ' + (active + 1) + ' of ' + packSize + ' — color';
      } else {
        if (ss) ss.textContent = '2. Choose your size';
        if (cs) cs.textContent = '3. Choose your color';
      }

      var mix = root.querySelector('[data-mix-note]');
      if (mix && packSize > 1) {
        mix.textContent = full
          ? 'Your pack is full. Press Change on any band to swap it.'
          : (mix.getAttribute('data-default') || mix.textContent);
      }

      renderTray();

      var cur = find(draft.size, draft.color);
      var pre = packSize > 1 ? anyPreorder() : !!(cur && cur.preorder);
      var callout = root.querySelector('[data-preorder-callout]');
      if (callout) callout.hidden = !pre;
      if (preorderProperty) {
        var singlePreorder = packSize === 1 && pre;
        preorderProperty.disabled = !singlePreorder;
        preorderProperty.value = 'PRE-ORDER · Ships first week of September 2026';
      }
      if (deliveryReassurance) {
        deliveryReassurance.textContent = pre
          ? 'Pre-order - Ships First Week of September'
          : 'typically 5–10 business days';
      }

      // Low stock urgency — only shown when the band is in stock but running out.
      var low = packSize > 1 ? lowestInPack() : ((cur && cur.low) ? cur : null);
      var lowCallout = root.querySelector('[data-lowstock-callout]');
      if (lowCallout) {
        lowCallout.hidden = !low;
        if (low) {
          var lt = lowCallout.querySelector('[data-lowstock-text]');
          if (lt) {
            lt.textContent = 'Only ' + low.qty + ' left in ' + low.sizeShort + ' — ' + low.colorShort + '. The next batch ships the first week of September 2026.';
          }
        }
      }

      if (packSize === 1 && cur && String(select.value) !== String(cur.id)) {
        select.value = String(cur.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (qtyInput) qtyInput.value = 1;
      form.classList.toggle('is-pack', packSize > 1);

      var label, disabled;
      if (packSize === 1) {
        if (!cur) { label = 'Choose a size and color'; disabled = true; }
        else if (cur.preorder) { label = 'Pre-order - Ships First Week of September'; disabled = false; }
        else if (!cur.available) { label = 'Sold out'; disabled = true; }
        else { label = 'Add to cart'; disabled = false; }
      } else {
        disabled = !isFull();
        label = isFull()
          ? (pre ? 'Pre-order ' + packSize + ' bands - Ships First Week of September' : 'Add ' + packSize + ' bands to cart')
          : 'Choose ' + (packSize - filled()) + ' more';
      }
      if (submitBtn) { submitBtn.textContent = label; submitBtn.disabled = disabled; }
      if (stickyBtn) {
        stickyBtn.disabled = disabled;
        stickyBtn.textContent = (packSize === 1 && label === 'Add to cart') ? 'Get Your Bible Band' : label;
      }
    }

    root.addEventListener('click', function (ev) {
      var p = ev.target.closest('[data-pack-choice]');
      if (p) { setPack(Number(p.getAttribute('data-pack-choice'))); return; }

      var ed = ev.target.closest('[data-edit-slot]');
      if (ed) {
        var idx = Number(ed.getAttribute('data-edit-slot'));
        var sl = slots[idx];
        active = idx;
        if (sl) { draft = { size: sl.size, color: sl.color }; slots[idx] = null; }
        render();
        return;
      }

      var s = ev.target.closest('[data-band-size]');
      if (s) {
        draft.size = s.getAttribute('data-band-size');
        if (packSize > 1) { if (!commit()) render(); }
        else { slots[0] = draft.color ? { size: draft.size, color: draft.color } : null; render(); }
        return;
      }

      var c = ev.target.closest('[data-band-color]');
      if (c) {
        draft.color = c.getAttribute('data-band-color');
        if (packSize > 1) { if (!commit()) render(); }
        else { slots[0] = draft.size ? { size: draft.size, color: draft.color } : null; render(); }
        return;
      }

      var h = ev.target.closest('[data-size-help-toggle]');
      if (h) {
        var panel = root.querySelector('[data-size-help]');
        var open = h.getAttribute('aria-expanded') === 'true';
        h.setAttribute('aria-expanded', String(!open));
        if (panel) panel.hidden = open;
      }
    });

    form.addEventListener('submit', function (ev) {
      if (packSize < 2) return;
      ev.preventDefault();
      if (!isFull()) return;
      var packHasPreorder = anyPreorder();
      var items = slots.map(function (s) {
        var v = find(s.size, s.color);
        var item = { id: v.id, quantity: 1 };
        if (packHasPreorder) {
          item.properties = {
            'Ships': v.preorder
              ? 'PRE-ORDER · Ships first week of September 2026'
              : 'WITH PRE-ORDER · Entire order ships first week of September 2026'
          };
        }
        return item;
      });
      var original = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      }).catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = original || 'Try again'; }
      });
    });

    var mixEl = root.querySelector('[data-mix-note]');
    if (mixEl) mixEl.setAttribute('data-default', mixEl.textContent.trim());

    setPack(1);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () { document.querySelectorAll('[data-band-options]').forEach(init); });
})();
